import { CellCoords } from "../../../../models/yield.models";
import { HotTable } from "@handsontable-pro/react";

interface ContextMenuItem {
  name: string;
  key?: string;
  callback?: (
    name: string,
    selection: Array<{ start: CellCoords; end: CellCoords }>,
    clickEvent: MouseEvent,
  ) => void;
  disabled: () => boolean;
  hidden: () => boolean;
  isCommand?: boolean;
  submenu?: {
    items: Array<{
      key: string;
      name: string;
      callback: (
        itemName: string,
        selection: Array<{ start: CellCoords; end: CellCoords }>,
      ) => void;
    }>;
  };
}

export function getItems(
  this: HotTable["hotInstance"],
  ys: any,
  instance: Handsontable,
  isDisabled: boolean | null,
  isRewardsEnabled: Boolean,
): {
  [item: string]: ContextMenuItem;
} {
  if (isDisabled) {
    return {};
  }
  // horrible hack for production

  const items = {
    CLOSE_DAY: getDaySubMenuItem(
      ys,
      "apply",
      "Close",
      isDisabled,
      isRewardsEnabled,
    ),
    OPEN_DAY: getDaySubMenuItem(
      ys,
      "remove",
      "Open",
      isDisabled,
      isRewardsEnabled,
    ),
    MINLOS2: getMinDayMenuItem(ys, "apply", "Apply min LOS 2", isDisabled),
    REMOVEMINLOS: getMinDayMenuItem(ys, "remove", "Remove min LOS", isDisabled),
  };

  return items;
}

function getDaySubMenuItem(
  ys: any,
  type: string,
  name: string,
  isDisabled: boolean | null,
  isRewardsEnabled: Boolean,
): ContextMenuItem {
  const contextMenu: ContextMenuItem = {
    name,
    key: `${type}_day`,
    disabled() {
      return false;
    },
    hidden() {
      if (isDisabled) {
        return true;
      }
      const hotInstance: HotTable["hotInstance"] = this;
      const selectedLast = hotInstance.getSelectedLast();
      const selectedRangeLast = hotInstance.getSelectedRangeLast();

      if (!selectedLast || !selectedRangeLast) {
        return true;
      }

      const col = selectedLast[1];
      if (col === 0) {
        return true;
      }
      const { row } = selectedRangeLast.highlight;
      return row !== 1;
    },
  };
  const items: any[] = [];
  items.push({
    key: `${type}_day:all`,
    name: "All Rooms",
    callback: (itemName: any, selection: any) => {
      if (
        !selection ||
        !Array.isArray(selection) ||
        !selection[0] ||
        !selection[0].start
      ) {
        console.error("Invalid selection:", selection);
        return;
      }
      const col = selection[0].start.col;
      ys.closeOrOpenDay(col, type, "all");
    },
  });
  items.push({
    key: `${type}_day:ota`,
    name: "OTA Rates",
    callback: (itemName: any, selection: any) => {
      if (
        !selection ||
        !Array.isArray(selection) ||
        !selection[0] ||
        !selection[0].start
      ) {
        console.error("Invalid selection:", selection);
        return;
      }
      const col = selection[0].start.col;
      ys.closeOrOpenDay(col, type, "ota");
    },
  });
  items.push({
    key: `${type}_day:ows`,
    name: "OWS Rates",
    callback: (itemName: any, selection: any) => {
      if (
        !selection ||
        !Array.isArray(selection) ||
        !selection[0] ||
        !selection[0].start
      ) {
        console.error("Invalid selection:", selection);
        return;
      }
      const col = selection[0].start.col;
      ys.closeOrOpenDay(col, type, "ows");
    },
  });
  items.push({
    key: `${type}_day:gds`,
    name: "GDS Rates",
    callback: (itemName: any, selection: any) => {
      if (
        !selection ||
        !Array.isArray(selection) ||
        !selection[0] ||
        !selection[0].start
      ) {
        console.error("Invalid selection:", selection);
        return;
      }
      const col = selection[0].start.col;
      ys.closeOrOpenDay(col, type, "gds");
    },
  });
  if (isRewardsEnabled === true) {
    items.push({
      key: `${type}_day:rewards`,
      name: "Rewards Rates",
      callback: (itemName: any, selection: any) => {
        if (
          !selection ||
          !Array.isArray(selection) ||
          !selection[0] ||
          !selection[0].start
        ) {
          console.error("Invalid selection:", selection);
          return;
        }
        const col = selection[0].start.col;
        ys.closeOrOpenDay(col, type, "rewards");
      },
    });
  }
  contextMenu.submenu = { items };

  return contextMenu;
}

function getMinDayMenuItem(
  ys: any,
  type: string,
  name: string,
  isDisabled: boolean | null,
): ContextMenuItem {
  return {
    name: name,
    disabled() {
      //not so necessary since we hide all disabled items!
      return false;
    },
    hidden() {
      if (isDisabled) {
        return true;
      }
      const hotInstance: HotTable["hotInstance"] = this;
      if (hotInstance.getSelectedLast()[1] === 0) {
        return true;
      }
      const { row } = hotInstance.getSelectedRangeLast().highlight;
      return row !== 1;
    },
    callback: (itemName: any, selection: any) => {
      const col = selection[0].start.col;
      ys.minDayForDay(col, type);
    },
  };
}
